import { Stack, Typography } from '@mui/material';
import { useCalculusTFunction } from '@retail/calculus/i18n';

interface Props {
  totalCount: number;
}

export const ConditionCount = ({ totalCount }: Props) => {
  const t = useCalculusTFunction();

  return (
    <Stack flexDirection="row" gap={0.5} alignItems="center">
      <Typography variant="body2">{t('calculus.showing')}</Typography>
      <Typography variant="body2" fontWeight="bold">{totalCount ?? 0}</Typography>
      <Typography variant="body2">
        {totalCount === 1 ? t('calculus.oneCondition') : t('calculus.nrOfConditions')}
      </Typography>
    </Stack>
  );
};
